import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { OverlayEventDetail } from '@ionic/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Validators } from '@angular/forms';
import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';
import { GSDIntlTelInputModal } from './gsd-intl-tel-input-modal';
import { GSDIntlTelInputCountryCode } from './gsd-intl-tel-input-country-code';
import {
  GSDIntlTelInputCountry,
  GSDPhoneNumber,
  GSDPhoneValidationCodes,
} from './gsd-intl-tel-input-country';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { AnalyticsService } from '../../services/analytics.service';

@Component({
  selector: 'gsd-intl-tel-input',
  templateUrl: './gsd-intl-tel-input.component.html',
  styleUrls: ['./gsd-intl-tel-input.component.scss'],
})
export class GsdIntlTelInputComponent implements OnInit {
  phoneForm: FormGroup;

  // Input
  @Input('phone') inPhone: any; // ex: { 'us', '+1' '5551239876' }
  @Input('disabled') disabled: any;

  // Output
  @Output() public gsdPhone = new EventEmitter();

  // Lists of Countries
  countryCodeData: GSDIntlTelInputCountryCode;

  preferredCountries: any[] = [];

  allCountryData: any[] = [];
  preferredCountryData: any[] = [];

  // Active Selections
  activeCountry: GSDIntlTelInputCountry;
  activeNumber: GSDPhoneNumber;

  constructor(
    private analytics: AnalyticsService,
    public modalCtrl: ModalController,
    private fb: FormBuilder,
  ) {
    this.activeNumber = new GSDPhoneNumber();
    this.activeCountry = new GSDIntlTelInputCountry();

    this.gsdPhone = new EventEmitter();

    // Country Code List Data
    this.countryCodeData = new GSDIntlTelInputCountryCode();

    this.preferredCountries = [];
    this.preferredCountries.push('us');
    this.preferredCountries.push('ca');

    this.allCountryData = [];
    this.preferredCountryData = [];

    this.fetchCountryData();

    /*
    if( this.user_op != 'signup' ) {

      let phone_number: string = this.mapStateToUser('user_phone');

      if( typeof( phone_number ) == 'string' && phone_number.length > 0 ) {
        this.phone_number = phone_number;
        var countryCode = this.getCountryCodeFromNumber(this.phone_number);
        this.activeCountry = this.getCountryFromCountryCode(countryCode);
		console.log( countryCode );

        this.phone_number = this.stripCountryCodeFromNumber(this.phone_number);
        console.log('formatted: ' + this.phone_number);
      }
    }
    */
  }

  ngOnInit() {
    this.initialize(false);
  }

  // In case changes came later.
  ngOnChanges() {
    console.log('phone changes');
    //this.initialize(true); // (2022/6/30 --mh) This seemed to cause an issue in the AddMemberForm where a phone number could not be deleted completely.
  }

  initialize(changes) {
    // In case changes came later.

    this.setActiveNumber();
    this.setFormValues();
    if (changes) {
      this.onPhoneNumberChange();
    }
  }

  setActiveNumber() {
    /*
    this.activeNumber.code = "+1";
    this.activeNumber.area    = "";
    this.activeNumber.prefix  = "";
    this.activeNumber.line    = "";
    */

    /*
    countryTag: string;
    country: string;
    area: string;
    prefix: string;
    line: string;
    */

    //console.log('inCountry: ' + this.inCountry );
    //console.log('inPhone:  ' + this.inPhone.countryTag );

    /*
    var value = {
      'valid':   this.activeNumber.valid,
      'full':    this.activeNumber.full,
      'countryTag': this.activeCountry.tag,
      'country': split[0],
      'area':    split[1],
      'prefix':  split[2],
      'line':    split[3]
    }
    */

    console.log('phone in', this.inPhone);

    var split = this.inPhone.friendly
      .replace(/[(]|[)]/gm, '')
      .replace('-', ' ')
      .split(' ');

    this.inPhone.area = split[1];
    this.inPhone.prefix = split[2];
    this.inPhone.line = split[3];

    this.activeCountry = this.getCountryFromCountryTag(this.inPhone.countryTag);

    this.activeNumber.code = this.activeCountry.code;
    this.activeNumber.number = this.formatToPhone(
      this.inPhone.area + this.inPhone.prefix + this.inPhone.line,
    );

    //console.log( 'this.ActiveNumber: ', this.activeNumber );
  }

  setFormValues() {
    /*
    this.phoneForm = this.fb.group({
      country: [ this.activeNumber.code, Validators.required],
      area:    [ this.activeNumber.area, Validators.required],
      prefix:  [ this.activeNumber.prefix, Validators.required],
      line:    [ this.activeNumber.line, Validators.required],
    });
    */
    this.phoneForm = this.fb.group({
      country: [this.activeNumber.code, Validators.required],
      number: [this.activeNumber.number, Validators.required],
    });

    // disable the control if we were passed disable
    if (typeof this.disabled != 'undefined') {
      this.disabled = true;
      this.phoneForm.controls['number'].disable();
    }
  }

  setCountryValue() {
    this.phoneForm = this.fb.group({
      country: [this.activeNumber.code, Validators.required],
    });
  }

  onPhoneNumberChange() {
    console.log('onPhoneNumberChange');

    var code = '+' + this.activeCountry.code + ' ';

    /*
    if( this.phone_number.length > code.length ) {

      var value = code + this.phone_number.substring(code.length, this.phone_number.length);
      this.phone_number = value;
    }
    else {
      this.phone_number = code;
    }
    */

    //console.log( this.phoneForm.get('number').value );

    var value = {
      valid: GSDPhoneValidationCodes.INVALID,
      friendly: '',
      full: '',
      countryTag: this.activeCountry.tag,
      country: '',
      area: '',
      prefix: '',
      line: '',
    };

    this.activeNumber.number = this.phoneForm.get('number').value;

    if (this.activeNumber.number.replace(/\D/g, '').length > 0) {

      this.activeNumber.number = this.formatToPhone(this.activeNumber.number.replace(/\D/g, ''));

      this.activeNumber.friendly =
        this.activeNumber.code + ' ' + this.activeNumber.number;

      //console.log(this.activeNumber.friendly );

      // Is phone number valid?
      var number = '';

      this.activeNumber.valid = GSDPhoneValidationCodes.INVALID;

      //console.log( typeof this.activeNumber.number + ' ' + this.activeNumber.number.replace(/\D/g, '').length );

      if (
        typeof this.activeNumber.number != undefined &&
        this.activeNumber.number.replace(/\D/g, '').length > 1
      ) {
        var phoneUtil = PhoneNumberUtil.getInstance();

        // Is this a valid number?
        var isValidNumber = phoneUtil.parse(
          this.activeNumber.friendly,
          this.activeCountry.tag,
        );
        isValidNumber = phoneUtil.isValidNumber(isValidNumber);

        // If this was a valid number, strip out all characters other than numbers before we send.
        if (isValidNumber) {
          this.activeNumber.valid = GSDPhoneValidationCodes.VALID;
          number = '+' + this.activeNumber.friendly.replace(/\D/g, '');
        }
      } else {
        this.activeNumber.valid = GSDPhoneValidationCodes.INVALID;
      }

      var split = this.activeNumber.friendly
        .replace(/[(]|[)]/gm, '')
        .replace('-', ' ')
        .split(' ');

      if (typeof split[1] == undefined) split[1] = '';
      if (typeof split[2] == undefined) split[2] = '';
      if (typeof split[3] == undefined) split[3] = '';

      value = {
        valid: this.activeNumber.valid,
        friendly: this.activeNumber.friendly,
        full: '+' + this.activeNumber.friendly.replace(/\D/g, ''),
        countryTag: this.activeCountry.tag,
        country: split[0],
        area: split[1],
        prefix: split[2],
        line: split[3],
      };

      this.gsdPhone.emit(value);
    }
  }

  onInputKeyPress(event) {
    var /** @type {?} */ pattern = /[0-9\+\-\ ]/;
    var /** @type {?} */ inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  onInputKeyDown(event) {
    var code = '+' + this.activeNumber.code + ' ';
    if (this.activeNumber.friendly.length <= code.length) {
      if (event.keyCode == 8) {
        event.preventDefault();
      }
    }
  }

  fetchCountryData() {
    var _this = this;

    this.countryCodeData.allCountries.forEach(function (c) {
      var country = new GSDIntlTelInputCountry();
      country.name = c[0].toString();
      country.tag = c[1].toString();
      country.code = c[2].toString();
      country.flagClass = country.tag.toLocaleLowerCase();
      country.placeHolder = _this.getPhoneNumberPlaceHolder(
        country.tag.toUpperCase(),
      );

      _this.allCountryData.push(country);
    });

    if (this.preferredCountries.length) {
      this.preferredCountries.forEach(function (tag) {
        var preferredCountry = _this.allCountryData.filter(function (c) {
          return c.tag === tag;
        });
        _this.preferredCountryData.push(preferredCountry[0]);
      });
    }

    if (this.preferredCountryData.length) {
      this.activeCountry = this.preferredCountryData[0];
    } else {
      this.activeCountry = this.allCountryData[0];
    }

    /*
    console.log( this.allCountryData );
    console.log( this.preferredCountries );
    console.log( this.preferredCountryData );
    console.log( this.activeCountry );
    */
  }

  getPhoneNumberPlaceHolder(countryCode) {
    var /** @type {?} */ phoneUtil = PhoneNumberUtil.getInstance();
    var /** @type {?} */ pnf = PhoneNumberFormat;
    try {
      var /** @type {?} */ phoneNumber = phoneUtil.parse(
          '2236512366',
          countryCode,
        );
      return phoneUtil.format(phoneNumber, pnf.INTERNATIONAL);
    } catch (e) {
      //console.log('CountryCode: "' + countryCode + '" ' + e);
      return e;
    }
  }

  getCountryCodeFromNumber(phone_number) {
    var phoneUtil = PhoneNumberUtil.getInstance();
    var valid = phoneUtil.parse(phone_number, '');
    var countryCode = valid.getCountryCode();
    return countryCode;
  }

  getCountryFromCountryTag(countryTag) {
    console.log('getCodeFromCountryTag: ' + countryTag);
    //console.log( this.allCountryData );

    let country: GSDIntlTelInputCountry;

    this.allCountryData.forEach(function (c) {
      if (c.tag == countryTag) {
        country = c;
      }
    });

    return country;
  }

  getCountryFromCountryCode(countryCode) {
    console.log('getCountryFromCountryCode: ' + countryCode);
    //console.log( this.allCountryData );

    let country: GSDIntlTelInputCountry;

    this.allCountryData.forEach(function (c) {
      if (c.code == countryCode) {
        country = c;
      }
    });

    return country;
  }

  stripCountryCodeFromNumber(phone_number: string) {
    console.log('stripCountryCodeFromNumber: ' + phone_number);

    let code: string = '+' + this.activeCountry.code;

    //console.log('code    ' + code + ' ' + code.length );
    //console.log('phoneNumber ' + phone_number + ' ' + phone_number.length );
    phone_number =
      '+' +
      this.activeCountry.code +
      ' ' +
      phone_number.substr(code.length, phone_number.length);

    return phone_number;
  }

  async onClick() {
    this.analytics.track('qt_country_code', { ui: true });
    var _this = this;

    if (_this.disabled) return;

    if (typeof this.activeCountry == 'undefined') {
      this.activeCountry = this.getCountryCodeFromNumber('+15555555555');
    }

    const modal = await this.modalCtrl.create({
      component: GSDIntlTelInputModal,
      componentProps: {
        allCountries: this.allCountryData,
        preferredCountries: this.preferredCountryData,
        activeCountry: this.activeCountry,
      },
    });

    modal.onWillDismiss().then((modal: OverlayEventDetail) => {
      // Did the user select somethign valid?
      if (
        typeof modal == 'undefined' ||
        typeof modal.data == 'undefined' ||
        typeof modal.data.country == 'undefined'
      ) {
        return;
      } else {
        // Update the active country and update the form with the country code.
        this.activeCountry = modal.data.country;
        this.activeNumber.code = this.activeCountry.code;

        this.setCountryValue();
      }
    });
    return await modal.present();
  }

  //

  /*const*/ isNumericInput(event) {
    const key = event.keyCode;
    return (
      (key >= 48 && key <= 57) || // Allow number line
      (key >= 96 && key <= 105) // Allow number pad
    );
  }

  /*const*/ isModifierKey(event) {
    const key = event.keyCode;

    return (
      event.shiftKey === true ||
      key === 35 ||
      key === 36 || // Allow Shift, Home, End
      key === 8 ||
      key === 9 ||
      key === 13 ||
      key === 46 || // Allow Backspace, Tab, Enter, Delete
      (key > 36 && key < 41) || // Allow left, up, right, down
      // Allow Ctrl/Command + A,C,V,X,Z
      ((event.ctrlKey === true || event.metaKey === true) &&
        (key === 65 || key === 67 || key === 86 || key === 88 || key === 90))
    );
  }

  /*const*/ enforceFormat(event) {
    // Input must be of a valid number format or a modifier key, and not longer than ten digits
    if (!this.isNumericInput(event) && !this.isModifierKey(event)) {
      event.preventDefault();
    }
  }

  /*const*/

  formatToPhoneEvent(event) {
    if (this.isModifierKey(event)) {
      return;
    }

    // I am lazy and don't like to type things more than once
    const target = event.target;
    target.value = this.formatToPhone(target.value);
  }

  formatToPhone(value) {
    //console.log('formatToPhone: ', value );

    if (!value) return '';

    const input = value.replace(/\D/g, '').substring(0, 10); // First ten digits of input only
    const zip = input.substring(0, 3);
    const middle = input.substring(3, 6);
    const last = input.substring(6, 10);

    if (input.length > 6) {
      value = `(${zip}) ${middle}-${last}`;
    } else if (input.length > 3) {
      value = `(${zip}) ${middle}`;
    } else if (input.length > 0) {
      value = `(${zip}`;
    }

    return value;
  }
}
